import React, { useState } from 'react';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-logo">
          <span className="logo-text">BuildNex</span>
        </div>
        
        <div className={`nav-menu ${isOpen ? 'active' : ''}`}>
          <button className="nav-item" onClick={() => scrollToSection('home')}>Home</button>
          <button className="nav-item" onClick={() => scrollToSection('about')}>About</button>
          <button className="nav-item" onClick={() => scrollToSection('services')}>Services</button>
          <button className="nav-item" onClick={() => scrollToSection('why-us')}>Why Us</button>
          <button className="nav-item" onClick={() => scrollToSection('contact')}>Contact</button>
        </div>

        <div className="nav-toggle" onClick={toggleMenu}>
          <span className={`bar ${isOpen ? 'active' : ''}`}></span>
          <span className={`bar ${isOpen ? 'active' : ''}`}></span>
          <span className={`bar ${isOpen ? 'active' : ''}`}></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
